import { Snackbar, styled } from 'opensolar-ui'
import { PromoContentElements } from 'persistentContent/promoDialog/elements/PromoContentElements'
import { FC } from 'react'
import ToastActions from './ToastActions'
import { ToastNotification as ToastType } from './useToastNotificationStructs'

interface PropTypes {
  open: boolean
  onClose: () => void
  toastNotif: ToastType
  onInteract: () => void
  trackingKey: string | undefined
}

const StyledSnackbar = styled(Snackbar, { name: 'StyledSnackbar' })(({ theme }) => ({
  padding: 0,
  '& .OSUI-SnackbarContent-message': {
    width: '100%',
    padding: 0,
    color: theme.palette.text.primary,
  },
  '& .OSUI-Paper-root': {
    padding: 0,
  },
  [theme.breakpoints.down('md')]: {
    bottom: 70,
  },
}))

const SnackWrapper = styled('div', { name: 'SnackWrapper' })({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: 380,
  maxHeight: 340,
  overflowY: 'auto',
})

const ToastNotification: FC<PropTypes> = ({ open, onClose, trackingKey, toastNotif, onInteract }) => {
  const { elements, cta_label, dismiss_label, cta_link } = toastNotif
  return (
    <StyledSnackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      open={open}
      onClose={onClose}
      message={
        <>
          <SnackWrapper className="os-scroll">
            <PromoContentElements
              elements={elements}
              trackingSource={trackingKey}
              onNext={onClose}
              eventId="toast_notification_video_played"
            />
          </SnackWrapper>
          <ToastActions
            onClick={onInteract}
            onClose={onClose}
            ctaLabel={cta_label}
            dismissLabel={dismiss_label}
            clickUrl={cta_link}
          />
        </>
      }
    />
  )
}

export default ToastNotification
